import { render, staticRenderFns } from "./dproprice.vue?vue&type=template&id=4380009a&scoped=true"
import script from "./dproprice.vue?vue&type=script&lang=js"
export * from "./dproprice.vue?vue&type=script&lang=js"
import style0 from "./dproprice.vue?vue&type=style&index=0&id=4380009a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4380009a",
  null
  
)

export default component.exports